import { useEffect, useRef, useState } from "react";
import jwt_decode from "jwt-decode";
import { NumberFormatMoney } from "../useForm";
import format from 'format-number'
import { Alert, Autocomplete, Box, Button, Checkbox, Collapse, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControlLabel, FormGroup, Grid, IconButton, InputAdornment, Link, TextField, Tooltip } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import CloseIcon from '@mui/icons-material/Close';
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import TipsAndUpdatesTwoToneIcon from '@mui/icons-material/TipsAndUpdatesTwoTone';
import es from "date-fns/locale/es";
import ComprobantesViaticosListado from "./ComprobantesViaticosListado";
import ComprobantesRegistradosViaticosListado from "./ComprobantesRegistradosViaticosListado";
import PreviewTwoToneIcon from '@mui/icons-material/PreviewTwoTone';

const options = [{ id: 'conComprobante', label: 'Con comprobante' }, { id: 'aComprobar', label: 'A comprobar' }]
const optionsTipoEvento = [{ id: 'ponencia', label: 'Ponencia' }, { id: 'conferencia', label: 'Conferencia' }, { id: 'presentacionLibro', label: 'Presentación de libro' }, { id: 'practicaCampo', label: 'Práctica de campo' }, { id: 'trabajoCampo', label: 'Trabajo en campo' }, { id: 'noAplica', label: 'No aplica' }]

export default function Conferenciante(props) {
    const token = sessionStorage.getItem('token')
    const decoded = jwt_decode(token);
    const idResponsable = decoded.id;
    const [anio, setAnio] = useState(null)
    const [configuracion, setConfiguracion] = useState(null)
    const [pais, setPais] = useState({ "codigo": "MX", "nombre": "MEXICO" })
    const [indice, setIndice] = useState(1)
    const [factura, setFactura] = useState({ monto: null, fecha: null, documentos: new FormData(), indice: 0, rutaPDF: null, rutaXML: null })
    const [montoComprometido, setMontoComprometido] = useState(0)
    const [conferenciante, setConferenciante] = useState({
        tipoServicio: { id: 'conComprobante', label: 'Con comprobante' }, nombreEvento: null,
        carta: new FormData(), tipoEvento: null, monto: null, fechaInicio: null, fechaFin: null,
        sede: null, actividad: null, pais: null, ciudad: 'Ciudad de México', idPartidaProyecto: null, observaciones: null,
        justificacion: null, rutaCarta: null
    })
    //const [expiroFecha, setExpiroFecha] = useState(false)
    const [proyectos, setProyectos] = useState([])
    const [paises, setPaises] = useState([])
    const [paisesFiltrados, setPaisesFiltrados] = useState([])
    const [proyecto, setProyecto] = useState(null)

    const [fechaInicio, setFechaInicio] = useState(null)

    const [tipoServicio, setTipoServicio] = useState({ id: 'conComprobante', label: 'Con comprobante' })
    const [fechaFin, setFechaFin] = useState(null)
    const [fechaInicioFacturacion, setFechaInicioFacturacion] = useState(null)
    const [fechaFinFacturacion, setFechaFinFacturacion] = useState(null)
    //const [partidas, setPartidas] = useState([]);
    const [fechas, setFechas] = useState(null)
    const [partidasProyecto, setPartidasProyecto] = useState([])
    const [partida, setPartida] = useState(null);

    const [sinConfiguracionFechas, setSinConfiguracionFechas] = useState(false)
    const [errorMonto, setErrorMonto] = useState(false)
    const [helperTextMonto, setHelperTextMonto] = useState('')
    const [errorMontoAvion, setErrorMontoAvion] = useState(false)
    const [helperTextMontoAvion, setHelperTextMontoAvion] = useState('')
    const [errorProyectoSinPartidas, setErrorProyectoSinPartidas] = useState(false)
    const [helperTextProyectoSinPartidas, setHelperTextProyectoSinPartidas] = useState('')
    const [errorFechaInicio, setErrorFechaInicio] = useState(false)
    const [helperTextFechaInicio, setHelperTextFechaInicio] = useState('')
    const [errorFechaFin, setErrorFechaFin] = useState(false)
    const [helperTextFechaFin, setHelperTextFechaFin] = useState('')
    const [errorFecha, setErrorFecha] = useState(false)
    const [helperTextFecha, setHelperTextFecha] = useState('')
    const [errorDocumentoPDF, setErrorDocumentoPDF] = useState(false)
    const [helperTextDocumentoPDF, setHelperTextDocumentoPDF] = useState('')
    const [errorDocumentoXML, setErrorDocumentoXML] = useState(false)
    const [helperTextDocumentoXML, setHelperTextDocumentoXML] = useState('')
    const [errorCarta, setErrorCarta] = useState(false)
    const [helperTextCarta, setHelperTextCarta] = useState('')

    const [openMensaje, setOpenMensaje] = useState(false);
    const [mensaje, setMensaje] = useState('');
    const [open, setOpen] = useState(false);
    const [checkedComprobante, setCheckedComprobante] = useState(false);
    const [checkedAvion, setCheckedAvion] = useState(false);
    const [montoAvion, setMontoAvion] = useState(false);
    const [facturas, setFacturas] = useState([]);
    const [facturasRegistradas, setFacturasRegistradas] = useState([]);
    const [loading, setLoading] = useState(false)
    const [severity, setSeverity] = useState('error')
    const limpiar = useRef(null)

    const mostrarDocumento = async (value, tipo) => {
        //console.log(`value en desplegarDocumentoPDF ${value}`)
        await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/servicios/mostrarFactura`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil'),
                "ruta": value,
                "tipo": tipo
            }
        }
        ).then((res) => res.blob())
            .then((blob) => { // RETRIEVE THE BLOB AND CREATE LOCAL URL
                var _url = window.URL.createObjectURL(blob);
                window.open(_url, "_blank").focus(); // window.open + focus
            }).catch((err) => {
                console.error(err);
            });
    }

    const colocarNombre = (ruta) => {
        if (!ruta || ruta === '')
            return ''
        const indice = Number(ruta.indexOf("cartas")) + 7
        return ruta.slice(indice)

    }

    const handleChecked = (event) => {
        setCheckedComprobante(event.target.checked);
    };
    const handleCheckedAvion = (event) => {
        setCheckedAvion(event.target.checked);
        if (!event.target.checked)
            setMontoAvion(null)
    };

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setErrorMonto(false)
        setHelperTextMonto('')
        setHelperTextDocumentoPDF('')
        setErrorDocumentoPDF(false)
        setHelperTextDocumentoXML('')
        setErrorDocumentoXML(false)
    };

    const leerPaises = async () => {
        const paisesLeidos = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/paises/`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil')
            }
        })
        const paisesJson = await paisesLeidos.json()
        //console.log(paisesJson)
        setPaises(paisesJson)
        return paisesJson
    }

    const leerUsuario = async () => {

        const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/informeProyecto/proyectos/${idResponsable}/false/${sessionStorage.getItem('idEntidad')}`, { //Siempre es gestión por eso se pone false
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil')
            }
        })
        if (res.status === 404) {
            //console.log('regresó 404 en Viaticos')//poner mensaje de error
            return
        }
        else {
            //console.log('si hay proyectos')
            const data = await res.json()
            //console.log(data)

            setProyectos(data)

            const idPlan = data[0].idPlan
            //console.log(`IDPLAN ${data[0].idPlan}`)
            const resPlan = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/planeacion/${idPlan}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": sessionStorage.getItem('token'),
                    "perfil": sessionStorage.getItem('perfil')
                }
            }
            )
            const plan = await resPlan.json()
            // console.log(`ANIO ${plan.anio}`)
            setAnio(plan.anio)
            await cargarFechas(plan.anio)
            // console.log(`ANIO ${plan.anio}`)
            const entidad = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/entidad/${sessionStorage.getItem('idEntidad')}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": sessionStorage.getItem('token'),
                    "perfil": sessionStorage.getItem('perfil')
                }
            })
            const entidadLeida = await entidad.json()
            if (plan.anio) {
                const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/configuracionMontos/configuracion/${plan.anio}/${entidadLeida.idEntidadSuperior ? entidadLeida.idEntidadSuperior : entidadLeida.id}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": sessionStorage.getItem('token'),
                        "perfil": sessionStorage.getItem('perfil')
                    }
                }

                )
                if (res.status === 404) {
                    setOpenMensaje(true)
                    setMensaje(`La configuración de montos ${plan.anio} no existe.`)
                    setConfiguracion(null)
                }
                else {
                    const data = await res.json()
                    // console.log(`CONFIGURACION ${data}`)
                    setConfiguracion({ ...data })
                }
            }
        }

    }

    const { idSolicitud, seEnviaCorreo, setIdSolicitud, verificarDisponible } = props;

    useEffect(() => {
        (async () => {
            await leerUsuario();
            const paises = await leerPaises();
            if (idSolicitud) {

                const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/conferenciante/solicitud/${idSolicitud}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": sessionStorage.getItem('token'),
                        "perfil": sessionStorage.getItem('perfil')
                    }
                })

                const conferenciante = await res.json()

                setMontoComprometido(Number(conferenciante.monto))
                //console.log(`conferenciante ${JSON.stringify(conferenciante)}`)
                //console.log(`montoAvion ${conferenciante.montoAvion > 0}`)
                setCheckedAvion(conferenciante.montoAvion > 0)
                setMontoAvion(conferenciante.montoAvion ? conferenciante.montoAvion : 0)
                conferenciante.monto = (Number(conferenciante.monto) - Number(conferenciante.montoAvion)).toFixed(2)
                conferenciante.carta = new FormData()
                const fechaInicioAux = conferenciante.fechaInicio ? new Date(conferenciante.fechaInicio) : null
                setFechaInicioFacturacion(conferenciante.fechaInicio ? new Date(conferenciante.fechaInicio) : null)
                setFechaInicio(fechaInicioAux ? fechaInicioAux.setDate(fechaInicioAux.getDate() + 1) : null);
                const fechaFinAux = conferenciante.fechaFin ? new Date(conferenciante.fechaFin) : null
                setFechaFin(fechaFinAux ? fechaFinAux.setDate(fechaFinAux.getDate() + 1) : null);
                setFechaFinFacturacion(fechaFinAux ? fechaFinAux.setDate(fechaFinAux.getDate() + 1) : null)
                setPais(paises.filter(paises => paises.nombre === conferenciante.pais)[0])

                setFacturasRegistradas(conferenciante.facturaCIs)
                //console.log(`conferenciante.tipoEvento antes ${conferenciante.tipoEvento}`)
                setConferenciante({ ...conferenciante, tipoEvento: optionsTipoEvento.filter(tipoEvento => tipoEvento.id === conferenciante.tipoEvento)[0] })
                //conferenciante.tipoEvento = optionsTipoEvento.filter(tipoEvento => tipoEvento.id === conferenciante.tipoEvento)[0]
                //console.log(`conferenciante.tipoEvento después ${JSON.stringify(conferenciante.tipoEvento)}`)
                setTipoServicio(options.filter(tipoServicio => tipoServicio.id === conferenciante.tipoServicio)[0])
                const resPartida = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/partidasProyecto/${conferenciante.idPartidaProyecto}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": sessionStorage.getItem('token'),
                        "perfil": sessionStorage.getItem('perfil')
                    }
                })
                const partida = await resPartida.json()
                setPartida(partida)

                const resProyecto = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/proyectosPlan/proyecto/${partida.idProyectoPlan}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": sessionStorage.getItem('token'),
                        "perfil": sessionStorage.getItem('perfil')
                    }
                })
                const proyecto = await resProyecto.json()
                setProyecto(proyecto)
                const resPartidasProyecto = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/partidasProyecto/proyecto/${proyecto.id}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": sessionStorage.getItem('token'),
                        "perfil": sessionStorage.getItem('perfil')
                    }
                })

                const partidasProyectoLeidas = await resPartidasProyecto.json()
                const partidasProyectoLectura = partidasProyectoLeidas.filter(partidasProyectoLeidas => Number(partidasProyectoLeidas.clave) < 5000000 || Number(partidasProyectoLeidas.clave) > 5999999)
                //Mostrar sólo las no 5000
                //console.log(`transferenciasDestino.clave ${JSON.stringify(transferenciasDestino[0].partida.clave)}`)

                if (partidasProyectoLectura && partidasProyectoLectura.length > 0) {
                    // console.log(`Dentrto del if ${JSON.stringify(partidasProyectoLectura)}`)
                    setErrorProyectoSinPartidas(false)
                    setHelperTextProyectoSinPartidas('')
                    setPartidasProyecto(partidasProyectoLectura)
                    /*const partidasViaticos = partidasProyectoLectura.filter(partidasProyectoLectura => Number(partidasProyectoLectura.clave) === 3750401 || Number(partidasProyectoLectura.clave) === 3760201)
                    console.log(`Dentrto del if ${JSON.stringify(partidasViaticos)}`)
                    if (partidasViaticos && partidasViaticos.length > 0) {
                        setErrorProyectoSinPartidas(false)
                        setHelperTextProyectoSinPartidas('')
                        setPartidasProyecto(partidasViaticos)
                    }
                    else {
                        setErrorProyectoSinPartidas(true)
                        setHelperTextProyectoSinPartidas('Este proyecto no tiene partidas 3750401-Viáticos en Territorio Nacional 3760201-Viáticos en el extranjero')
                        setPartidasProyecto([])
                    }*/
                }
                else {
                    setErrorProyectoSinPartidas(true)
                    setHelperTextProyectoSinPartidas('Este proyecto no tiene partidas')
                }
                const partidaSeleccionada = partidasProyectoLectura.filter(partida => partida.idPartidaProyecto === conferenciante.idPartidaProyecto)[0]
                //console.log(`PAISES FILTRADOS = ${JSON.stringify(paises.filter(paises => paises.nombre === "MEXICO"))}`)
                if (Number(partidaSeleccionada.clave) === Number(3750401))
                    setPaisesFiltrados(paises.filter(paises => paises.nombre === "MEXICO"))
                if (Number(partidaSeleccionada.clave) === Number(3760201))
                    setPaisesFiltrados(paises.filter(paises => paises.nombre !== "MEXICO"))

            }


        })();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        setConferenciante({...conferenciante, facturaCIs: facturasRegistradas})
    }, [facturasRegistradas]);
    /*
        const calcularMonto = async (fechaFin, fechaInicio, nombre) => {
            console.log(`calculando monto....${fechaFin} - ${fechaInicio}`)
            var x = new Date(fechaFin);
            var y = new Date(fechaInicio);
    
            // segundos = milisegundos/1000
            // minutos = segundos/60
            // horas = minutos/60
            // Días = horas/24
    
            const dias = Math.floor((x - y) / (1000 * 60 * 60 * 24)) + 1;
            console.log(`dias ${dias}`);
            //obtener entidad para cargar la configuración de montos
            let montoCalculado;
            if (configuracion) {
    
                if (nombre === 'MEXICO')
                    montoCalculado = Number(configuracion.montoMaximoNacionalDia) * Number(dias)
    
                else
                    montoCalculado = Number(configuracion.montoMaximoInternacionalDia) * Number(dias)
                setConferenciante({ ...conferenciante, [`monto`]: montoCalculado })
    
                const fechaPrioridad2 = new Date(fechas.activarMontosPrioridad2)
                fechaPrioridad2.setDate(fechaPrioridad2.getDate() + 1);
                let montoDisponible = Number(partida.prioridad1Disponible)
                if (Date.now() >= Date.parse(fechaPrioridad2)) {
                    montoDisponible += Number(partida.prioridad2Disponible)
                }
                //console.log(`fecha prioridad 2 ${fechaPrioridad2}`)
                //setViaticos({ ...viaticos, 'monto': montoCalculado })
    
                if (Number(montoCalculado) > Number(montoDisponible)) {
                    setErrorMonto(true)
                    setHelperTextMonto(`No hay presupuesto suficiente en esta partida ${format({ prefix: '$' })(montoDisponible)}. Puede solicitar una transferencia a esta partida si así lo requiere.`)
                }
                else {
                    setErrorMonto(false)
                    setHelperTextMonto('')
                }
                console.log(`ErrorMonto ${errorMonto} valor ${montoCalculado} partida.montoDisponible ${montoDisponible}`)
            }
        }
    */
    const cargarFechas = async (anio) => {
        const entidad = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/entidad/${sessionStorage.getItem('idEntidad')}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil')
            }
        })
        const entidadLeida = await entidad.json()
        const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/configuracionFechas/configuracion/${anio}/${entidadLeida.idEntidadSuperior ? entidadLeida.idEntidadSuperior : entidadLeida.id}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil')
            }
        })
        const fechasLeidas = await res.json()
        // console.log(`status ${res.status}`)
        if (res.status === 404) {
            setMensaje('Aún no se ha establecido la configuración de fechas, solicite a la Asistencia Administrativa que la registre')
            setOpenMensaje(true)
            setSinConfiguracionFechas(true)
        }
        setFechas(fechasLeidas)
        const fechaCierreAdquisiciones = new Date(fechasLeidas.cierreAdquisiciones)
        fechaCierreAdquisiciones.setDate(fechaCierreAdquisiciones.getDate() + 1);
    }

    const almacenarTemporalmente = async (e) => {
        e.preventDefault()
        //setDocumentoError(true)
        /* PONER EN SUBMIT const archivoPDF = new FormData();
        archivoPDF.append('documento', documentoComentario.documentos.get('PDF'));
        const resUploadPDF = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/uploadDocumento`, {
            method: "POST",
            body: archivoPDF
        })
        const ruta = (await resUploadPDF.json()).ruta
    
        documentoComentario.ruta = ruta*/
        setIndice(indice + 1)
        factura.indice = indice
        factura.esComprobante = checkedComprobante || pais.nombre !== 'MEXICO' 
        //console.log(`factura ${JSON.stringify(factura)}`)
        facturas.splice(0, 0, { ...factura })
        setFactura({ monto: null, fecha: null, documentos: new FormData() })
        if (limpiar.current)
            limpiar.current.click()
        setHelperTextDocumentoPDF('')
        setHelperTextDocumentoXML('')
    }


    const handleSubmit = async (e) => {
        e.preventDefault()
        setLoading(true)
        
        await Promise.all(facturas.map(async (factura) => {
            if (!factura.rutaPDF) {
                const archivoPDF = new FormData();
                archivoPDF.append('factura', factura.documentos.get('PDF'));
                const resUploadPDF = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/uploadFacturas`, {
                    method: "POST",
                    headers: { "escomprobante": factura.esComprobante},
                    body: archivoPDF
                })
                const ruta = (await resUploadPDF.json()).ruta
                
                factura.rutaPDF = ruta
            }
            if (!factura.rutaXML) {
                if (factura.documentos.get('XML')) {
                    const archivoXML = new FormData();
                    archivoXML.append('factura', factura.documentos.get('XML'));
                    const resUploadXML = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/uploadFacturas`, {
                        method: "POST",
                        body: archivoXML
                    })
                    factura.rutaXML = (await resUploadXML.json()).ruta
                }
            }
        })
        )
        if (conferenciante.carta.get('carta')) {
            const resUploadCarta = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/uploadCartas`, {
                method: "POST",
                body: conferenciante.carta
            })
            conferenciante.rutaCarta = (await resUploadCarta.json()).ruta
        }
        conferenciante.fechaInicio = fechaInicio
        conferenciante.fechaFin = fechaFin
        conferenciante.pais = pais.nombre
        conferenciante.idPartidaProyecto = partida.idPartidaProyecto
        conferenciante.tipoServicio = tipoServicio.id
        conferenciante.tipoEvento = conferenciante.tipoEvento.id
        if (montoAvion)
            conferenciante.monto = Number(conferenciante.monto) + Number(montoAvion ? montoAvion : 0)

        /*console.log(`DATOS ${JSON.stringify({
            idSolicitante: idResponsable,
            anio,
            conferenciante,
            facturas,
            idProyecto: proyecto.id,
            claveProyecto: proyecto.clave,
            descripcionProyecto: proyecto.descripcion
        })}`)*/

        if (idSolicitud) {
            const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/conferenciante/${conferenciante.id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": sessionStorage.getItem('token'),
                    "perfil": sessionStorage.getItem('perfil')
                },
                body: JSON.stringify({
                    idSolicitante: idResponsable,
                    anio,
                    conferenciante,
                    facturas,
                    idProyecto: proyecto.id,
                    claveProyecto: proyecto.clave,
                    descripcionProyecto: proyecto.descripcion,
                    partida,
                    seEnviaCorreo
                })
            })
            if (res.status === 200) 
                setSeverity('success')
            else
                setSeverity('error')
            const data = await res.json()

            if (data.message) {
                conferenciante.monto = Number(conferenciante.monto) - Number(conferenciante.montoAvion)
                setConferenciante({ ...conferenciante, tipoEvento: optionsTipoEvento.filter(tipoEvento => tipoEvento.id === conferenciante.tipoEvento)[0] })
                conferenciante.carta = new FormData()
                setOpenMensaje(true)
                setMensaje(data.message)
                setLoading(false)
                return
            }
            else {
                setOpenMensaje(true)
                setMensaje("Se registró la solicitud.")
            }
            setLoading(false)
        }
        else {
            const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/servicios/conferencianteInvitado`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": sessionStorage.getItem('token'),
                    "perfil": sessionStorage.getItem('perfil')
                },
                body: JSON.stringify({
                    idSolicitante: idResponsable,
                    anio,
                    conferenciante,
                    facturas,
                    idProyecto: proyecto.id,
                    claveProyecto: proyecto.clave,
                    descripcionProyecto: proyecto.descripcion,
                    partida,
                    idEntidad: sessionStorage.getItem('idEntidad'),
                    seEnviaCorreo
                })
            })

            const data = await res.json()
            if (res.status === 200) {
                setSeverity('success')
                setProyecto(null)
                setPartidasProyecto([])
                setPartida(null)
                setConferenciante({
                    tipoServicio: { id: 'conComprobante', label: 'Con comprobante' }, nombreEvento: null,
                    carta: new FormData(), tipoEvento: null, monto: null, fechaInicio: null, fechaFin: null,
                    sede: null, actividad: null, pais: null, ciudad: 'Ciudad de México', idPartidaProyecto: null, observaciones: null,
                    justificacion: null, rutaCarta: null
                })
                setFechaInicio(null)
                setFechaFin(null)
                setFacturas([])
                setLoading(false)
                setIdSolicitud(data.solicitud.id)
            }
            else
                setSeverity('error')
            if (data.message) {
                setOpenMensaje(true)
                setMensaje(data.message)
                setLoading(false)
                return
            }
            else {
                setOpenMensaje(true)
                setMensaje("Se registró la solicitud.")
            }
            setLoading(false)
        }
    }

    return (
        <>
            <form onSubmit={handleSubmit}>
                <Grid container justifyContent='stretch' spacing={5} style={{ marginTop: 5 }}>
                    <Grid item xs={12} sm={4}>
                        <Autocomplete
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                            getOptionLabel={(option) => option.clave + '-' + option.descripcion}
                            value={proyecto ? proyecto : null}
                            onChange={async (event, newValue) => {
                                // console.log(newValue)
                                setProyecto(newValue)
                                setPartida(null)
                                if (newValue) {
                                    const res2 = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/partidasProyecto/proyecto/${newValue.id}`, {
                                        method: "GET",
                                        headers: {
                                            "Content-Type": "application/json",
                                            "x-access-token": sessionStorage.getItem('token'),
                                            "perfil": sessionStorage.getItem('perfil')
                                        }
                                    })

                                    const partidasProyectoLeidas = await res2.json()
                                    const partidasProyectoLectura = partidasProyectoLeidas.filter(partidasProyectoLeidas => Number(partidasProyectoLeidas.clave) < 5000000 || Number(partidasProyectoLeidas.clave) > 5999999)
                                    // console.log(`partidasProyectoLectura ${JSON.stringify(partidasProyectoLectura)}`)

                                    if (partidasProyectoLectura && partidasProyectoLectura.length > 0) {
                                        setErrorProyectoSinPartidas(false)
                                        setHelperTextProyectoSinPartidas('')
                                        setPartidasProyecto(partidasProyectoLectura)
                                    }
                                    else {
                                        setErrorProyectoSinPartidas(true)
                                        setHelperTextProyectoSinPartidas('Este proyecto no tiene partidas 3750401-Viáticos en Territorio Nacional 3760201-Viáticos en el extranjero')
                                        setPartidasProyecto([])
                                    }
                                    /*  Sólo activar si se requieren partidas específicas como en viáticos
                                      const partidasConferenciante = partidasProyectoLectura.filter(partidasProyectoLectura => Number(partidasProyectoLectura.clave) === 3750401 || Number(partidasProyectoLectura.clave) === 3760201)
  
                                      if (partidasConferenciante && partidasConferenciante.length > 0) {
                                          setErrorProyectoSinPartidas(false)
                                          setHelperTextProyectoSinPartidas('')
                                          setPartidasProyecto(partidasConferenciante)
                                      }
                                      else {
                                          setErrorProyectoSinPartidas(true)
                                          setHelperTextProyectoSinPartidas('Este proyecto no tiene partidas 3750401-Viáticos en Territorio Nacional 3760201-Viáticos en el extranjero')
                                          setPartidasProyecto([])
                                      }*/
                                }

                            }}
                            id="proyecto"
                            name="proyecto"
                            options={proyectos}
                            sx={{ width: '100%' }}
                            renderInput={(params) => <TextField {...params} label={`Proyecto`} focused helperText={helperTextProyectoSinPartidas} error={errorProyectoSinPartidas} required multiline />}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        {partidasProyecto ? partidasProyecto.length > 0 ?
                            <Autocomplete
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                getOptionLabel={(option) => option.clave + '-' + option.concepto}
                                value={partida ? partida : null}
                                onChange={async (event, newValue) => {
                                    // console.log(`newValue ${JSON.stringify(newValue)}`)
                                    setPartida(newValue)
                                    setPaisesFiltrados(paises)
                                    /* desactivar sólo si hubiera diferencia como en viaticos nacionales y en el extranjero
                                    if (Number(newValue.clave) === Number(3750401))
                                        setPaisesFiltrados(paises.filter(paises => paises.nombre === "MEXICO"))
                                    if (Number(newValue.clave) === Number(3760201))
                                        setPaisesFiltrados(paises.filter(paises => paises.nombre !== "MEXICO"))*/
                                }}
                                id="partida"
                                name="partida"
                                options={partidasProyecto}
                                sx={{ width: '100%' }}
                                renderInput={(params) => <TextField {...params} label={`Partida`} focused required multiline />}
                            />
                            : <></> : <></>}

                    </Grid>
                    {partida ? <>
                        <Grid item xs={12} sm={4}>
                            <Autocomplete
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                getOptionLabel={(option) => option.label}
                                value={tipoServicio}
                                onChange={async (event, newValue) => {
                                    // console.log(`tipo Servicio cambio ${newValue}`)

                                    if (newValue)
                                        setTipoServicio(newValue)
                                    else
                                        setTipoServicio({ id: null, label: '' })
                                    setCheckedAvion(false)
                                    setMontoAvion(null)
                                    /*if (newValue ? newValue.id === 'conComprobante' : false)
                                        setConferenciante({ ...conferenciante, 'monto': 2000 })
                                    else {
                                        setConferenciante({ ...conferenciante, 'monto': null })
                                        setFacturas([])
                                    }*/
                                    if (newValue ? newValue.id === 'aComprobar' : false) {
                                        // console.log(`fechaInicio ${fechaInicio} fechaFin ${fechaFin} pais ${JSON.stringify(pais)} viaticos.tipoServicio = ${newValue ? newValue.id : false}`)
                                        /*if (fechaInicio && fechaFin && pais)
                                            await calcularMonto(fechaFin, fechaInicio, pais.nombre)
                                        else
                                            setConferenciante({ ...conferenciante, 'monto': null })*/
                                    }
                                }}
                                id="tipoServicio"
                                name="tipoServicio"
                                options={options}
                                sx={{ width: '100%' }}
                                renderInput={(params) => <TextField {...params} label={`Tipo de trámite`} focused required />}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <Autocomplete
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                getOptionLabel={(option) => option.label}
                                value={conferenciante.tipoEvento ? conferenciante.tipoEvento : null}
                                onChange={async (event, newValue) => {
                                    //console.log(newValue)
                                    setConferenciante({ ...conferenciante, [`tipoEvento`]: newValue })

                                }}
                                id="tipoEvento"
                                name="tipoEvento"
                                options={optionsTipoEvento}
                                sx={{ width: '100' }}
                                renderInput={(params) => <TextField {...params} label={`Tipo de evento`} focused required />}
                            />
                        </Grid>
                        <Grid item xs={12} sm={8}>
                            <TextField label={`Nombre del evento`} id='nombreEvento' name='nombreEvento' value={conferenciante.nombreEvento} focused required={conferenciante.tipoEvento === null || (conferenciante.tipoEvento !== null && conferenciante.tipoEvento.id !== 'noAplica')} multiline maxRows={5} sx={{ width: '100%' }} onChange={(e) => {
                                const valor = e.target.value
                                setConferenciante({ ...conferenciante, [e.target.name]: valor })
                                //setProductoServicio(valor)
                            }} />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <TextField label='Carta de invitación, aceptación o inscripción (PDF)' id='carta' name='carta' focused required={!idSolicitud && (conferenciante.tipoEvento === null || (conferenciante.tipoEvento !== null && conferenciante.tipoEvento.id !== 'noAplica'))} type='file' accept="application/pdf" helperText={helperTextCarta} error={errorCarta} onChange={(event) => {
                                conferenciante.carta.delete('carta')
                                const file = event.target.files[0]
                                if (event.target.value) {
                                    if (event.target.value.endsWith(".PDF") || event.target.value.endsWith(".pdf")) {
                                        setHelperTextCarta('')
                                        setErrorCarta(false)
                                    }
                                    else {
                                        setHelperTextCarta('Formato de archivo no válido, se requiere PDF')
                                        setErrorCarta(true)
                                        return
                                    }
                                    if (file.size > 5242880) {
                                        setHelperTextCarta('El tamaño del archivo debe ser menor a 5MB')
                                        setErrorCarta(true)
                                        return
                                    }
                                    else {
                                        setHelperTextCarta('')
                                        setErrorCarta(false)
                                    }
                                    //console.log(`event.target.value.match(/[A-Za-z0-9_-]/gi) ${event.target.files[0].name.match(/[A-Za-z0-9_-]/gi)} ${event.target.files[0].name.match(/[A-Za-z0-9_-]/gi).length} cadena ${event.target.files[0].name.length}`)
                                    // Si la longitud coincide significa que sólo se encontraron letras, números y guiones

                                    setHelperTextCarta('')
                                    setErrorCarta(false)
                                }
                                // console.log(`Files[0] ${file.name}`)
                                conferenciante.carta.append('carta', file)
                            }} sx={{ width: '100%' }} />
                            {conferenciante.rutaCarta ?
                                <Link style={{ cursor: 'pointer' }} onClick={async () => { await mostrarDocumento(conferenciante.rutaCarta, 'pdf') }} target='_blank'>{colocarNombre(conferenciante.rutaCarta)}<PreviewTwoToneIcon></PreviewTwoToneIcon></Link> :
                                <></>
                            }
                        </Grid>

                        <Grid item xs={12} sm={8}>
                            <TextField label={`Actividad`} id='actividad' name='actividad' value={conferenciante.actividad} focused required={conferenciante.tipoEvento === null || (conferenciante.tipoEvento !== null && conferenciante.tipoEvento.id !== 'noAplica')} maxRows={5} sx={{ width: '100%' }} onChange={(e) => {
                                const valor = e.target.value
                                setConferenciante({ ...conferenciante, [e.target.name]: valor })
                            }} />
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <Autocomplete
                                isOptionEqualToValue={(option, value) => option.codigo === value.codigo}
                                getOptionLabel={(option) => option.nombre}
                                value={pais ? pais : null}
                                onChange={async (event, newValue) => {
                                    // console.log(newValue)
                                    setPais(newValue)

                                    /* if (!newValue && tipoServicio.id === 'aComprobar')
                                         setConferenciante({ ...conferenciante, 'monto': null })*/

                                    //console.log(`viaticos.fechaInicio ${fechaInicio} \nviaticos.fechaFin ${fechaFin} \n viaticos.pais ${newValue.nombre}`)
                                    /*if (fechaInicio && fechaFin && newValue && tipoServicio.id === 'aComprobar')
                                        await calcularMonto(fechaFin, fechaInicio, newValue.nombre)*/
                                }}
                                id="pais"
                                name="pais"
                                options={paisesFiltrados}
                                sx={{ width: '100%' }}
                                renderInput={(params) => <TextField {...params} label={`Pais`} focused required />}

                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField label={`Ciudad`} id='ciudad' name='ciudad' value={conferenciante.ciudad} focused required multiline maxRows={5} sx={{ width: '100%' }} onChange={(e) => {
                                const valor = e.target.value
                                setConferenciante({ ...conferenciante, [e.target.name]: valor })
                            }} />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField label={`Sede`} id='sede' name='sede' value={conferenciante.sede} focused required={conferenciante.tipoEvento === null || (conferenciante.tipoEvento !== null && conferenciante.tipoEvento.id !== 'noAplica')} multiline maxRows={5} sx={{ width: '100%' }} onChange={(e) => {
                                const valor = e.target.value
                                setConferenciante({ ...conferenciante, [e.target.name]: valor })
                            }} />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
                                <DatePicker required label="Fecha inicio"
                                    value={fechaInicio}
                                    onChange={async (newValue) => {
                                        setFechaInicio(newValue)
                                        const fechaInicioF = new Date(newValue)
                                        setFechaInicioFacturacion(fechaInicioF.setDate(fechaInicioF.getDate() - 1))
                                        //console.log(`viaticos.fechaInicio ${fechaInicio} \nviaticos.fechaFin ${fechaFin} \n viaticos.pais ${pais ? pais.nombre : pais}`)
                                        setErrorFechaFin(false)
                                        setHelperTextFechaFin('')
                                        if (Date.parse(newValue) > Date.parse(fechaFin)) {
                                            setErrorFechaInicio(true)
                                            setHelperTextFechaInicio('La fecha de inicio no puede ser posterior a la fecha de fin')
                                            return
                                        }
                                        setErrorFechaInicio(false)
                                        setHelperTextFechaInicio('')

                                        /*if (newValue && fechaFin && pais && tipoServicio.id === 'aComprobar')
                                            await calcularMonto(fechaFin, newValue, pais.nombre)*/

                                    }}
                                    renderInput={(params) => <TextField {...params} name="fechaInicio" id="fechaInicio" required={conferenciante.tipoEvento === null || (conferenciante.tipoEvento !== null && conferenciante.tipoEvento.id !== 'noAplica')} focused variant='outlined' sx={{ width: '100%' }}
                                        helperText={helperTextFechaInicio} error={errorFechaInicio} />}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
                                <DatePicker required label="Fecha fin"
                                    value={fechaFin}
                                    onChange={async (newValue) => {
                                        setFechaFin(newValue)
                                        const fechaFinF = new Date(newValue)
                                        setFechaFinFacturacion(fechaFinF.setDate(fechaFinF.getDate() + 1))
                                        //console.log(`viaticos.fechaInicio ${fechaInicio} \nviaticos.fechaFin ${fechaFin} \n viaticos.pais ${pais ? pais.nombre : pais}`)
                                        setErrorFechaInicio(false)
                                        setHelperTextFechaInicio('')
                                        if (Date.parse(newValue) < Date.parse(fechaInicio)) {
                                            setErrorFechaFin(true)
                                            setHelperTextFechaFin('La fecha de fin no puede ser anterior a la fecha de inicio')
                                            return
                                        }
                                        setErrorFechaFin(false)
                                        setHelperTextFechaFin('')

                                        /* if (fechaInicio && newValue && pais && tipoServicio.id === 'aComprobar')
                                             await calcularMonto(newValue, fechaInicio, pais.nombre)*/

                                    }}
                                    renderInput={(params) => <TextField {...params} name="fechaFin" id="fechaFin" required={conferenciante.tipoEvento === null || (conferenciante.tipoEvento !== null && conferenciante.tipoEvento.id !== 'noAplica')} focused variant='outlined' sx={{ width: '100%' }}
                                        helperText={helperTextFechaFin} error={errorFechaFin} />}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField name='monto' label="Monto" required onChange={(e) => {
                                const valor = e.target.value
                                const valorNumerico = Math.abs(valor.replace(/,/g, ''))
                                const fechaPrioridad2 = new Date(fechas.activarMontosPrioridad2)
                                fechaPrioridad2.setDate(fechaPrioridad2.getDate() + 1);
                                let montoDisponible = Number(partida.prioridad1Disponible)
                                if (Date.now() >= Date.parse(fechaPrioridad2)) {
                                    montoDisponible += Number(partida.prioridad2Disponible)
                                }
                                // console.log(`fecha prioridad 2 ${fechaPrioridad2}`)
                                setConferenciante({ ...conferenciante, 'monto': valorNumerico })

                                if (verificarDisponible() && Number(valorNumerico) > Number((Number(montoDisponible) + Number(montoComprometido)).toFixed(2))) {
                                    setErrorMonto(true)
                                    setHelperTextMonto(`No debe exceder el monto disponible de la partida ${format({ prefix: '$' })(Number((Number(montoDisponible) + Number(montoComprometido)).toFixed(2)))}. Puede solicitar una transferencia a esta partida si así lo requiere.`)
                                }
                                else {
                                    setErrorMonto(false)
                                    setHelperTextMonto('')
                                }
                                // console.log(`ErrorMonto ${errorMonto} valor ${valorNumerico} partida.montoDisponible ${montoDisponible}`)
                            }} InputProps={{
                                inputComponent: NumberFormatMoney,
                                startAdornment: (
                                    <InputAdornment position="start">
                                        $
                                    </InputAdornment>
                                ),
                            }} value={conferenciante.monto} helperText={helperTextMonto} error={errorMonto} sx={{ width: '100%' }} />
                            <Tooltip title={tipoServicio.id === 'aComprobar' ? <> El monto se calcula con los montos máximos por día establecidos, así como las fechas de inicio y fin.</> : <>El monto máximo de reembolso es de $2,000</>} arrow><TipsAndUpdatesTwoToneIcon sx={{ color: 'orange' }} /></Tooltip>
                        </Grid>

                        {tipoServicio.id === 'conComprobante' ?
                            <Grid item xs={12}>
                                <FormGroup>
                                    <FormControlLabel control={<Checkbox checked={checkedAvion}
                                        onChange={handleCheckedAvion} inputProps={{ 'aria-label': 'controlled' }} />}
                                        label="Avión" />
                                </FormGroup>
                            </Grid> : <></>
                        }
                        {checkedAvion ?
                            <Grid item xs={12} sm={4}>
                                <TextField name='montoAvion' label="Monto Avión" required onChange={(e) => {
                                    const valor = e.target.value                                    
                                    const valorNumerico = Math.abs(valor.replace(/,/g, ''))
                                    const fechaPrioridad2 = new Date(fechas.activarMontosPrioridad2)
                                    fechaPrioridad2.setDate(fechaPrioridad2.getDate() + 1);
                                    let montoDisponible = Number(partida.prioridad1Disponible) - Number(2000)
                                    if (Date.now() >= Date.parse(fechaPrioridad2)) {
                                        montoDisponible += Number(partida.prioridad2Disponible)
                                    }
                                    // console.log(`fecha prioridad 2 ${fechaPrioridad2}`)
                                    setMontoAvion(valorNumerico)

                                    if (verificarDisponible() && Number(valorNumerico) > Number((Number(montoDisponible) + Number(montoComprometido)).toFixed(2))) {
                                        setErrorMontoAvion(true)
                                        setHelperTextMontoAvion(`No debe exceder el monto disponible de la partida ${format({ prefix: '$' })(Number((Number(montoDisponible) + Number(montoComprometido)).toFixed(2)))}. Puede solicitar una transferencia a esta partida si así lo requiere.`)
                                    }
                                    else {
                                        setErrorMontoAvion(false)
                                        setHelperTextMontoAvion('')
                                    }
                                    //console.log(`ErrorMontoAvion ${errorMontoAvion} valor ${valorNumerico} partida.montoDisponible ${montoDisponible}`)
                                }} InputProps={{
                                    inputComponent: NumberFormatMoney,
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            $
                                        </InputAdornment>
                                    ),
                                }} value={montoAvion} helperText={helperTextMontoAvion} error={errorMontoAvion} sx={{ width: '100%' }} />

                            </Grid>
                            : <></>}
                        <Grid item xs={12} sm={12}>
                            <TextField label={`Observaciones`} id='observaciones' name='observaciones' value={conferenciante.observaciones} focused multiline maxRows={5} sx={{ width: '100%' }}
                                onChange={(e) => {
                                    const valor = e.target.value
                                    setConferenciante({ ...conferenciante, [e.target.name]: valor })
                                }
                                } />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <TextField label={`Justificación`} id='justificacion' name='justificacion' value={conferenciante.justificacion} focused multiline maxRows={5} sx={{ width: '100%' }}
                                onChange={(e) => {
                                    const valor = e.target.value
                                    setConferenciante({ ...conferenciante, [e.target.name]: valor })
                                }
                                } />
                        </Grid></>
                        : <></>}
                </Grid>
                {(pais && fechaInicio && fechaFin && (tipoServicio.id === 'conComprobante')) || (conferenciante.tipoEvento && conferenciante.tipoEvento.id === 'noAplica' && tipoServicio.id === 'conComprobante') ?
                    <Grid item sx={{ marginTop: 5 }}>
                        <Button variant='contained' style={{ marginTop: 20, backgroundColor: "darkgreen", color: 'white' }} type='button' onClick={handleClickOpen}>
                            Añadir comprobantes
                        </Button>
                    </Grid> : <></>
                }
                {facturasRegistradas.length > 0 ? <ComprobantesRegistradosViaticosListado facturasRegistradas={facturasRegistradas} setFacturasRegistradas={setFacturasRegistradas} setOpenMensaje={setOpenMensaje}
                    setMensaje={setMensaje} idSolicitud={idSolicitud}></ComprobantesRegistradosViaticosListado> : <></>}
                {facturas.length > 0 ? <ComprobantesViaticosListado facturas={facturas} setFacturas={setFacturas}></ComprobantesViaticosListado> : <></>}
                {partida ?
                    <Grid item sx={{ marginTop: 5 }}>
                        <Button variant='contained' color='primary' type='submit' disabled={errorMonto || errorProyectoSinPartidas || errorMontoAvion || loading}>
                            Solicitar
                        </Button>
                    </Grid> : <></>
                }
            </form>

            {(pais && fechaInicio && fechaFin) || (conferenciante.tipoEvento && conferenciante.tipoEvento.id === 'noAplica' && tipoServicio.id === 'conComprobante') ?
                <Dialog open={open}>
                    <form onSubmit={almacenarTemporalmente}>
                        <DialogTitle>{'Añadir comprobante/factura'}</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                            </DialogContentText>
                            <Grid container justifyContent='stretch' spacing={5} style={{ marginTop: 5 }}>
                            {pais.nombre === 'MEXICO' ?
                                    <Grid item xs={12}>
                                        <FormGroup>
                                            <FormControlLabel control={<Checkbox checked={checkedComprobante}
                                                onChange={handleChecked} inputProps={{ 'aria-label': 'controlled' }} />}
                                                label="Zona nacional que no emite factura" />
                                        </FormGroup>
                                    </Grid> : <></>
                                }
                                <Grid item xs={12}>
                                    {conferenciante.tipoEvento && conferenciante.tipoEvento.id !== 'noAplica' ?
                                        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
                                            <DatePicker required label="Fecha"
                                                value={factura.fecha}
                                                onChange={async (newValue) => {
                                                    setFactura({ ...factura, 'fecha': newValue, 'monto': null })
                                                    //console.log(`viaticos.fechaInicio ${fechaInicio} \nviaticos.fechaFin ${fechaFin} \n viaticos.pais ${pais ? pais.nombre : pais}`)
                                                    setErrorFecha(false)
                                                    setHelperTextFecha('')
                                                    if (Date.parse(newValue) > fechaFinFacturacion || Date.parse(newValue) < fechaInicioFacturacion) {
                                                        setErrorFecha(true)
                                                        setHelperTextFecha(`La fecha no puede estar fuera del rango de fechas permitidas (${(new Date(fechaInicioFacturacion)).toLocaleString('es-MX', { day: "2-digit", month: "long", year: "numeric" })} al ${(new Date(fechaFinFacturacion)).toLocaleString('es-MX', { day: "2-digit", month: "long", year: "numeric" })}) un día antes y un día después del evento`)
                                                        return
                                                    }

                                                }}
                                                renderInput={(params) => <TextField {...params} name="fecha" id="fecha" required focused variant='outlined' style={{ width: '100%' }}
                                                    helperText={helperTextFecha} error={errorFecha} />}
                                            />
                                        </LocalizationProvider> : <></>}
                                    {conferenciante.tipoEvento && conferenciante.tipoEvento.id !== 'noAplica' && factura.monto ?
                                        <Tooltip title={<> El monto máximo a reembolsar es de $2000.00 {montoAvion ? `más el monto del avión ${format({ prefix: '$' })(montoAvion)}` : ''}</>} arrow><TipsAndUpdatesTwoToneIcon sx={{ color: 'orange' }} /></Tooltip> : <></>}
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField name="monto" id="monto" label="Monto" required disabled={(conferenciante.tipoEvento !== null && conferenciante.tipoEvento.id !== 'noAplica') ? (!factura.fecha ? true : false) : false} onChange={(e) => {
                                        const valor = e.target.value
                                        const valorNumerico = valor.replace(/,/g, '')

                                        setFactura({ ...factura, 'monto': valorNumerico })

                                        if (verificarDisponible() && Number(valorNumerico) > 2000 + montoAvion ? Number(montoAvion) : 0) {
                                            setErrorMonto(true)
                                            setHelperTextMonto(`No debe exceder el monto máximo de reembolso $2,000.00 ${montoAvion ? `más el monto del avión ${format({ prefix: '$' })(montoAvion)}` : ''}`)
                                            return
                                        }
                                        else {
                                            setErrorMonto(false)
                                            setHelperTextMonto('')
                                        }
                                        // Verificar que todas las facturas con la misma fecha no excedan el montoMaximoDia
                                        // y que el monto acumulado de todos los comprobantes y facturas no exceda el monto asignado

                                        let montoAcumulado = Number(valorNumerico)
                                        if (facturasRegistradas)
                                            facturasRegistradas.map((facturaRegistrada) => {

                                                montoAcumulado = Number(montoAcumulado) + Number(facturaRegistrada.monto)
                                            })
                                        facturas.map((facturaGuardada) => {

                                            montoAcumulado = Number(montoAcumulado) + Number(facturaGuardada.monto)
                                        })
                                        //console.log(`Number(viaticos.monto) ${conferenciante.monto}+Number(montoAvion?(montoAvion):0)${montoAvion?(montoAvion):0} < Number(montoAcumulado) ${montoAcumulado} && (Number(viaticos.monto)${viaticos.monto}+Number(montoAvion?montoAvion:0)${montoAvion?montoAvion:0}- Number(montoAcumulado)${montoAcumulado} - Number(valorNumerico) ${valorNumerico}`)
                                        if (Number(Number(conferenciante.monto) + Number(montoAvion ? (montoAvion) : 0)) < Number(montoAcumulado) && (Number(conferenciante.monto) + Number(montoAvion ? montoAvion : 0) - (Number(montoAcumulado) - Number(valorNumerico))) <= 0) {
                                            setErrorMonto(true)
                                            setHelperTextMonto(`Ya no se pueden añadir más comprobantes. La suma de los montos de los comprobantes ${format({ prefix: '$' })(montoAcumulado)} no debe exceder el monto asignado ${format({ prefix: '$' })(Number(conferenciante.monto) + Number(montoAvion ? (montoAvion) : 0))}.`)
                                            return
                                        }
                                        else {
                                            setErrorMonto(false)
                                            setHelperTextMonto('')
                                        }

                                        if (Number(conferenciante.monto) + Number(montoAvion ? (montoAvion) : 0) < Number(montoAcumulado) && (Number(conferenciante.monto) + Number(montoAvion ? montoAvion : 0) - (Number(montoAcumulado) - Number(valorNumerico))) > 0) {
                                            setHelperTextMonto(`Considerar sólo por ${format({ prefix: '$' })(Number(conferenciante.monto) + Number(montoAvion ? montoAvion : 0) - (Number(montoAcumulado) - Number(valorNumerico)))}.`)
                                            setFactura({ ...factura, 'monto': Number(conferenciante.monto) + Number(montoAvion ? montoAvion : 0) - (Number(montoAcumulado) - Number(valorNumerico)) })
                                            setErrorMonto(false)
                                            return
                                        }


                                    }} focused value={factura.monto} helperText={helperTextMonto} error={errorMonto} sx={{ width: '100%' }} />


                                    {!factura.fecha && (conferenciante.tipoEvento === null || (conferenciante.tipoEvento !== null && conferenciante.tipoEvento.id !== 'noAplica')) ? <Tooltip title={<> Antes de especificar el monto, debe seleccionar la fecha (para poder validar que no excede el monto máximo por día)</>} arrow><TipsAndUpdatesTwoToneIcon sx={{ color: 'orange' }} /></Tooltip> : <></>}
                                </Grid>

                                <Grid item xs={12}>
                                    <TextField label={`${pais.nombre === 'MEXICO' && !checkedComprobante ? 'Factura PDF' : 'Comprobante PDF, PNG, JPG, JPEG'}`} id='documentoPDF' name='documentoPDF' focused required type='file' accept="application/pdf" helperText={helperTextDocumentoPDF} error={errorDocumentoPDF} onChange={async (event) => {
                                        factura.documentos.delete('PDF')
                                        const file = event.target.files[0]
                                        if (event.target.value) {
                                            // console.log(`event.target.value ${event.target.value} ${event.target.value.endsWith(".jpg")}`)
                                            if (event.target.value.endsWith(".PDF") || event.target.value.endsWith(".pdf") || ((checkedComprobante || pais.nombre !== 'MEXICO') && (event.target.value.endsWith(".PNG") || event.target.value.endsWith(".png") || event.target.value.endsWith(".JPG") || event.target.value.endsWith(".jpg") || event.target.value.endsWith(".JPEG") || event.target.value.endsWith(".jpeg")))) {

                                                setHelperTextDocumentoPDF('')
                                                setErrorDocumentoPDF(false)
                                            }
                                            else {
                                                setHelperTextDocumentoPDF(`Formato de archivo no válido, se requiere PDF ${checkedComprobante || pais.nombre !== 'MEXICO' ? ' PNG, JPG o JPEG' : ''}`)
                                                setErrorDocumentoPDF(true)
                                                return
                                            }
                                            if (file.size > 5242880) {
                                                setHelperTextDocumentoPDF('El tamaño del archivo debe ser menor a 5MB')
                                                setErrorDocumentoPDF(true)
                                                return
                                            }
                                            else {
                                                setHelperTextDocumentoPDF('')
                                                setErrorDocumentoPDF(false)
                                            }

                                            setHelperTextDocumentoPDF('')
                                            setErrorDocumentoPDF(false)
                                            let regex = /([^-\w.]*)/gm;
                                            const nombreArchivo = file.name.replace(regex, '');

                                            let error = false
                                            facturas.map((facturaGuardada) => {
                                                if (facturaGuardada.rutaPDF && facturaGuardada.rutaPDF.includes(nombreArchivo)) {
                                                    setHelperTextDocumentoPDF('Ese documento ya está registrado en el listado de esta solicitud')
                                                    setErrorDocumentoPDF(true)
                                                    error = true
                                                }
                                            })
                                            facturasRegistradas.map((facturaGuardada) => {
                                                if (facturaGuardada.rutaPDF && facturaGuardada.rutaPDF.includes(nombreArchivo)) {
                                                    setHelperTextDocumentoPDF('Ese documento ya está registrado en el listado de esta solicitud')
                                                    setErrorDocumentoPDF(true)
                                                    error = true
                                                }
                                            })
                                            if (error)
                                                return
                                            if (checkedComprobante || pais.nombre !== 'MEXICO') {
                                               /* const resVerificar = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/servicios/verificarImagen`, {
                                                    method: "GET",
                                                    headers: {
                                                        "nombre": nombreArchivo,
                                                        "carpeta": "facturas"
                                                    }
                                                })
                                                if (resVerificar.status === 200) {
                                                    //setErrorDocumentoPDF(true)                                                    
                                                    setHelperTextDocumentoPDF('Ya existe un archivo registrado con ese nombre. Si no lo subiste tú en un intento anterior por favor renombra tu archivo y trata de subirlo de nuevo, de lo contrario se colocará el enlace al archivo existente')
                                                    const data = await resVerificar.json()
                                                    //console.log(`data ${data.ruta}`)
                                                    setFactura({ ...factura, rutaPDF: data.ruta })
                                                    return
                                                }
                                                else {
                                                    setFactura({ ...factura, rutaPDF: null })
                                                    setErrorDocumentoPDF(false)
                                                    setHelperTextDocumentoPDF('')
                                                }*/
                                            }
                                            else {

                                                const resVerificar = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/servicios/verificarPDF`, {
                                                    method: "GET",
                                                    headers: {
                                                        "nombre": nombreArchivo,
                                                        "carpeta": "facturas"
                                                    }
                                                })
                                                if (resVerificar.status === 200) {
                                                    //setErrorDocumentoPDF(true)
                                                    setHelperTextDocumentoPDF('Ya existe un archivo registrado con ese nombre. Si no lo subiste tú en un intento anterior por favor renombra tu archivo y trata de subirlo de nuevo, de lo contrario se colocará el enlace al archivo existente')
                                                    const data = await resVerificar.json()
                                                    //console.log(`data ${data.ruta}`)
                                                    setFactura({ ...factura, rutaPDF: data.ruta })
                                                    return
                                                }
                                                else {
                                                    setFactura({ ...factura, rutaPDF: null })
                                                    setErrorDocumentoPDF(false)
                                                    setHelperTextDocumentoPDF('')
                                                }
                                            }
                                        }
                                        //console.log(`Files[0] ${file.name}`)
                                        factura.documentos.append('PDF', file)
                                    }} sx={{ width: '100%' }} />
                                </Grid>
                                {pais.nombre === 'MEXICO' && !checkedComprobante ?
                                    <Grid item xs={12}>
                                        <TextField label='Factura XML' id='documentoXML' name='documentoXML' focused required type='file' accept="application/xml" helperText={helperTextDocumentoXML} error={errorDocumentoXML} onChange={async (event) => {
                                            factura.documentos.delete('XML')
                                            const file = event.target.files[0]
                                            if (event.target.value) {
                                                if (event.target.value.endsWith(".XML") || event.target.value.endsWith(".xml")) {
                                                    setHelperTextDocumentoXML('')
                                                    setErrorDocumentoXML(false)
                                                }
                                                else {
                                                    setHelperTextDocumentoXML('Formato de archivo no válido, se requiere XML')
                                                    setErrorDocumentoXML(true)
                                                    return
                                                }
                                                if (file.size > 5242880) {
                                                    setHelperTextDocumentoXML('El tamaño del archivo debe ser menor a 5MB')
                                                    setErrorDocumentoXML(true)
                                                    return
                                                }
                                                else {
                                                    setHelperTextDocumentoXML('')
                                                    setErrorDocumentoXML(false)
                                                }
                                                //console.log(`event.target.value.match(/[A-Za-z0-9_-]/gi) ${event.target.files[0].name.match(/[A-Za-z0-9_-]/gi)} ${event.target.files[0].name.match(/[A-Za-z0-9_-]/gi).length} cadena ${event.target.files[0].name.length}`)
                                                // Si la longitud coincide significa que sólo se encontraron letras, números y guiones

                                                setHelperTextDocumentoXML('')
                                                setErrorDocumentoXML(false)

                                                let regex = /([^-\w.]*)/gm;
                                                const nombreArchivo = file.name.replace(regex, '');

                                                let error = false
                                                facturas.map((facturaGuardada) => {
                                                    if (facturaGuardada.rutaXML && facturaGuardada.rutaXML.includes(nombreArchivo)) {
                                                        setHelperTextDocumentoXML('Ese documento ya está registrado en el listado de esta solicitud')
                                                        setErrorDocumentoXML(true)
                                                        error = true
                                                    }
                                                })
                                                facturasRegistradas.map((facturaGuardada) => {
                                                    if (facturaGuardada.rutaXML && facturaGuardada.rutaXML.includes(nombreArchivo)) {
                                                        setHelperTextDocumentoXML('Ese documento ya está registrado en el listado de esta solicitud')
                                                        setErrorDocumentoXML(true)
                                                        error = true
                                                    }
                                                })

                                                if (error)
                                                    return

                                                const resVerificar = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/servicios/verificarFacturaXML`, {
                                                    method: "GET",
                                                    headers: {
                                                        "nombre": nombreArchivo,
                                                        "carpeta": "facturas"
                                                    }
                                                })
                                                if (resVerificar.status === 200) {
                                                    //setErrorDocumentoXML(true)                                                    
                                                    setHelperTextDocumentoXML('Ya existe un archivo registrado con ese nombre. Si no lo subiste tú en un intento anterior por favor renombra tu archivo y trata de subirlo de nuevo, de lo contrario se colocará el enlace al archivo existente')
                                                    const data = await resVerificar.json()
                                                    //console.log(`data ${data.ruta}`)
                                                    setFactura({ ...factura, rutaXML: data.ruta })

                                                    return
                                                }
                                                else {
                                                    setErrorDocumentoXML(false)
                                                    setHelperTextDocumentoXML('')
                                                    setFactura({ ...factura, rutaXML: null })
                                                }
                                            }
                                            //  console.log(`Files[0] ${file.name}`)
                                            factura.documentos.append('XML', file)
                                            //factura.documentos.push(file)
                                        }} sx={{ width: '100%' }} />
                                    </Grid>
                                    : <></>}                                
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleClose}>Cerrar</Button>
                            <Button type='submit' disabled={errorMonto || errorFecha || sinConfiguracionFechas || errorDocumentoXML || errorDocumentoPDF}>Guardar</Button>
                            <Button type='reset' ref={limpiar} onClick={() => { setErrorDocumentoPDF(false); setErrorDocumentoXML(false); setHelperTextDocumentoPDF(''); setHelperTextDocumentoXML(''); setFactura({ monto: null, fecha: null, documentos: new FormData(), indice: 0, rutaPDF: null, rutaXML: null }) }}>Limpiar</Button>
                        </DialogActions>
                    </form>
                </Dialog>
                : <></>}

            <Box sx={{ width: '100%' }}>
                <Collapse in={openMensaje}>
                    <Alert severity={severity}
                        action={
                            <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                    setOpenMensaje(false);
                                }}
                            >
                                <CloseIcon fontSize="inherit" />
                            </IconButton>
                        }
                        style={{ marginTop: 30 }}
                    >
                        {mensaje}
                    </Alert>
                </Collapse>
            </Box>
        </>
    )
}